module.exports = __webpack_public_path__ + "static/media/holly-berry.12dac295.svg";